import { useEffect, Component } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Hockey from "@/pages/Hockey";
import TeamSports from "@/pages/TeamSports";
import Activewear from "@/pages/Activewear";
import CustomManufacturing from "@/pages/CustomManufacturing";
import About from "@/pages/About";
import Contact from "@/pages/Contact";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  render() {
    if (this.state.err) {
      return (
        <div className="min-h-screen bg-white flex items-center justify-center text-sm text-slate-500">
          Something went wrong — please refresh the page.
        </div>
      );
    }
    return this.props.children;
  }
}

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => {
        document.querySelector(hash)?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 120);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.0, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ScrollManager />
        <div className="min-h-screen bg-white text-navy">
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/hockey" element={<Hockey />} />
              <Route path="/team-sports" element={<TeamSports />} />
              <Route path="/activewear" element={<Activewear />} />
              <Route path="/manufacturing" element={<CustomManufacturing />} />
              <Route path="/custom-manufacturing" element={<Navigate to="/manufacturing" replace />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/products" element={<Navigate to="/hockey" replace />} />
              <Route path="/custom-teamwear" element={<Navigate to="/custom-manufacturing" replace />} />
              <Route path="/manufacturing" element={<Navigate to="/custom-manufacturing" replace />} />
              <Route path="/process" element={<Navigate to="/custom-manufacturing" replace />} />
              <Route path="/gallery" element={<Navigate to="/" replace />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
          <Toaster
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#FFFFFF",
                border: "1px solid #E2E8F0",
                color: "#0B132B",
              },
            }}
          />
        </div>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
